import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const SectionTitleStyled = styled.h3`
  font-size: 1.8rem;
  line-height: 2.4rem;
  letter-spacing: 0.1rem;
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  margin: 0 0 3rem;
`;

export const NoTasksTitleStyled = styled(SectionTitleStyled)`
  text-align: center;
  margin: 0;

  ${breakpointsMQ4.sm.down} {
    text-align: left;
  }
`;

export const SubscriberTasksListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  padding: 0;
  margin: 0;
`;

export const TasksWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InactiveTasksWrapperStyled = styled(TasksWrapperStyled)`
  margin-top: 8rem;
`;
